// src/Dashboard/Dashboardcolpagesss/Reportcolpagesss/Reportcolpagesss.js
import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "./Reportcolpagesss.css";

import {
  officerWiseData,
  getOfficerPendingComplaints,
  getOfficerWiseByDate, 
} from "../../../api/collectorApi";

export default function Reportcolpagesss() {
  const navigate = useNavigate();

  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
const { t } = useTranslation();
  const [selectedOfficer, setSelectedOfficer] = useState(null);
  const [selectedOfficerId, setSelectedOfficerId] = useState(null);

  const [pendingList, setPendingList] = useState([]);
  const [loadingPending, setLoadingPending] = useState(false);

  const [loadingOfficers, setLoadingOfficers] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const formatToDDMMYYYY = (dateString) => {
  if (!dateString) return "N/A";
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

  const [officerMetaMap, setOfficerMetaMap] = useState({});

  useEffect(() => {
    let mounted = true;

    const loadOfficers = async () => {
      setLoadingOfficers(true);

      try {
        const apiData = await officerWiseData();
        const safeArray = Array.isArray(apiData) ? apiData : [];

        const mapped = safeArray.map((o) => ({
          officerId: o.officerId || o.id || null,
          officer: o.name || "Unknown Officer",
          designation: o.designation || o.department || "—",
          totalComplaints: Number(o.totalAssigned ?? 0),
          closed: Number(o.resolved ?? 0),
          pending: Number(o.pending ?? 0),
        }));

        const meta = {};
        safeArray.forEach((o) => {
          const id = o.officerId || o.id || null;
          if (id) {
            meta[id] = {
              name: o.name || "Unknown Officer",
              designation: o.designation || o.department || "—",
            };
          }
        });

        if (!mounted) return;

        setReportData(mapped);
        setFilteredData(mapped);
        setOfficerMetaMap(meta);
      } catch (err) {
        console.error("Error loading officers:", err);
      } finally {
        if (mounted) setLoadingOfficers(false);
      }
    };

    loadOfficers();
    return () => (mounted = false);
  }, []);

  const formatDateParam = (d) => {
    if (!d) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleFilter = async () => {
    if (!startDate || !endDate) {
      setFilteredData(reportData);
      return;
    }

    const from = formatDateParam(startDate);
    const to = formatDateParam(endDate);

    setLoadingFilter(true);

    try {
      const filtered = await getOfficerWiseByDate(from, to);
      const safe = Array.isArray(filtered) ? filtered : [];

      const mapped = safe.map((o) => ({
        officerId: o.officerId || o.id || null,
        officer: o.name || "Unknown Officer",
        designation: o.designation || o.department || "—",
        totalComplaints: Number(o.totalAssigned ?? 0),
        closed: Number(o.resolved ?? 0),
        pending: Number(o.pending ?? 0),
      }));

      await new Promise((resolve) => setTimeout(resolve, 3000)); // Keep UX consistent

      setFilteredData(mapped);
    } catch (err) {
      console.error("Filtered API error:", err);
      await new Promise((resolve) => setTimeout(resolve, 3000));
      setFilteredData(reportData);
    } finally {
      setLoadingFilter(false);
    }
  };

  const fetchOfficerPending = async (officerId, officerName) => {
    setSelectedOfficer(officerName || officerMetaMap[officerId]?.name || "Officer");
    setSelectedOfficerId(officerId);
    setLoadingPending(true);
    setPendingList([]);

    try {
      const list = await getOfficerPendingComplaints(officerId);
      const safeList = Array.isArray(list) ? list : [];

      const mapped = safeList.map((g) => ({
        grievanceId: g.grievanceId || g.id || "N/A",
        citizenName: g.user?.name || "Unknown",
        title: g.title || g.description || "No Title",
       complaintDate: g.createdAt
  ? formatToDDMMYYYY(g.createdAt)
  : "N/A",

resolvedDate: g.resolvedAt
  ? formatToDDMMYYYY(g.resolvedAt)
  : "Pending",
        photo: "https://i.pravatar.cc/40?u=" + encodeURIComponent(g.user?.name || g.grievanceId || Math.random()),
      }));

      await new Promise((resolve) => setTimeout(resolve, 3000));

      setPendingList(mapped);
    } catch (err) {
      console.error("Error pending complaints:", err);
      await new Promise((resolve) => setTimeout(resolve, 3000));
      setPendingList([]);
    } finally {
      setLoadingPending(false);
    }
  };

  return (
    <div className="reportcolpagesss">
      <div className="reportcolheaderRow">
        <FaArrowLeft className="reportcolbackIcon" onClick={() => navigate(-1)} />
       <h2 className="reportcolheadingsss">
  {t("report.title")}
</h2>
      </div>

      <div className="reportcolfilters">
        <div className="reportcoldate-filter">
        <label>{t("report.startDate")}</label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
           placeholderText={t("report.selectStartDate")}
            maxDate={endDate || null}
            isClearable
          />
        </div>

        <div className="reportcoldate-filter">
         <label>{t("report.endDate")}</label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText={t("report.selectEndDate")}
            minDate={startDate || null}
            isClearable
          />
        </div>

        <button
          className="reportcolfilter-btn"
          onClick={handleFilter}
          disabled={loadingFilter || loadingOfficers}
        >
        {loadingFilter ? t("report.filtering") : t("report.applyFilter")}
        </button>
      </div>

      {loadingOfficers ? (
        <div style={{ padding: 20, textAlign: "center" }}>{t("report.loadingOfficers")}</div>
      ) : (
        <>
        <div class="reportcoltableWrapper">
          <table className="reportcolmodernTable">
            <thead>
              <tr>
               <th>{t("report.officerName")}</th>
<th>{t("report.designation")}</th>
<th>{t("report.totalComplaint")}</th>
<th>{t("report.complaintClosed")}</th>
<th>{t("report.complaintPending")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.officerId ?? index}>
                  <td>{item.officer}</td>
                  <td>{item.designation}</td>
                  <td>{item.totalComplaints}</td>
                  <td><span className="reportcolstatus closed">{item.closed}</span></td>
                  <td>
                    <span
                      className={`reportcolstatus ${item.pending > 0 ? "pending" : "closed"}`}
                      style={{ cursor: item.pending > 0 ? "pointer" : "default" }}
                      onClick={() => item.pending > 0 && item.officerId && fetchOfficerPending(item.officerId, item.officer)}
                    >
                      {item.pending}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </>
      )}

      {selectedOfficer && (
        <div className="reportcolmodal-overlay" onClick={() => { setSelectedOfficer(null); setSelectedOfficerId(null); setPendingList([]); }}>
          <div className="reportcolmodal-box" onClick={(e) => e.stopPropagation()}>
            <h3 className="reportcolmodal-title">{t("report.pendingComplaints")} – {selectedOfficer}</h3>

            <table className="reportcolmodalTable">
              <thead>
                <tr>
                  <th></th>
                  <th>{t("report.complaintBy")}</th>
<th>{t("report.complaintTitle")}</th>
<th>{t("report.complaintDate")}</th>
<th>{t("report.resolvedDate")}</th>
                </tr>
              </thead>

              <tbody>
                {loadingPending ? (
                  <tr><td colSpan={5} style={{ textAlign: "center" }}>{t("report.loadingPending")}</td></tr>
                ) : pendingList.length === 0 ?
                  (
                    <tr><td colSpan={5} style={{ textAlign: "center" }}>{t("report.noPending")}</td></tr>
                  ) :
                  (
                    pendingList.map((c, i) => (
                      <tr key={c.grievanceId ?? i}>
                        <td className="reportcolcitizenCell">
                          <img src={c.photo} alt="" className="reportcolprofileImg" />
                        </td>
                        <td>{c.citizenName}</td>
                        <td>{c.title}</td>
                        <td>{c.complaintDate}</td>
                        <td>{c.resolvedDate}</td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>

            <button className="reportcolcloseBtn" onClick={() => { setSelectedOfficer(null); setSelectedOfficerId(null); setPendingList([]); }}>
             {t("common.close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
